import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Button } from 'loyal-react'
import Modal from 'react-awesome-modal'

const ModalConfirm = props => (
  <Modal
    width='600'
    height='90%'
    effect='fadeInUp'
    visible={props.show}
  >
    <Fragment>
      <div className='modal-wrapper col-11 mx-auto bg-white radius px-2 py-3 border-bottom-lg border-color-featured'>
        <div className='row'>
          <div className='col-12'>
            <p className='txt-body-sm' data-partner={props.partner}>
              Para realizar o resgate é preciso ter cadastro no programa parceiro
            </p>
          </div>
          <div className='col-12 col-md-6  mt-2'>
            <Button
              id='MileageConfirm'
              name={'MileageConfirm'}
              className='cart-done nowrap mr-2 col-2'
              text='Cancelar'
              onClick={e => props.onClose()}
            />
          </div>
          <div className='col-12 col-md-6  mt-2'>

            {props.loadingPayment ? (
              <button
                className='btn-featured btn-icon'
                aria-label='Carregando...'
              >
                <div className='btn-loading mr-auto ml-auto'>
                  <div />
                  <div />
                  <div />
                  <div />
                </div>
              </button>
            ) : (
              <Button
                id='MileageConfirm'
                name={'MileageConfirm'}
                className='cart-done btn-featured  col-2'
                text='Confirmar'
                onClick={props.handlerFinalizePayment}
                loading={props.loadingPayment}
              />
            )}
          </div>
        </div>
      </div>
    </Fragment>
  </Modal>
)

ModalConfirm.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  handlerFinalizePayment: PropTypes.func,
  partner: PropTypes.string,
  loadingPayment: PropTypes.bool
}

export default ModalConfirm



// WEBPACK FOOTER //
// ./src/features/MileageRescue/ModalCofirm/ModalConfirm.js